// src/App.js - Fixed unused 'navigate' variable in Home component
import React, { useState, useEffect } from "react";
// Removed 'useNavigate' from this import as it's no longer used directly in THIS FILE
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getAuth, sendSignInLinkToEmail } from "firebase/auth";
import { app } from "./firebaseConfig";
import Form from "./Form"; // Assuming Form.js uses useNavigate internally
import Verify from "./Verify"; // Assuming Verify.js uses useNavigate internally
import Confirmation from "./Confirmation"; // Assuming Confirmation.js uses useNavigate internally
import logo from "./assets/logo.png";
import "./styles.css";

const auth = getAuth(app);

function Home() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [animateInput, setAnimateInput] = useState(false);
  // const navigate = useNavigate(); // <<--- ENSURE THIS LINE IS REMOVED / COMMENTED OUT

  const handleStartClick = () => {
    setShowEmailInput(true);
    setTimeout(() => setAnimateInput(true), 500);
  };

  const handleEmailSubmit = () => {
    if (!email) {
      setMessage("❌ Please enter your email.");
      return;
    }
    setMessage("Sending verification link...");

    const actionCodeSettings = {
      url: `${window.location.origin}/verify`,
      handleCodeInApp: true,
    };

    sendSignInLinkToEmail(auth, email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem("emailForSignIn", email);
        setMessage("✅ Verification link sent! Check your inbox.");
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        setMessage(`❌ Error: ${error.code || 'Failed to send link. Please try again.'}`);
      });
  };

  // Animation effect for fade-in lines
  useEffect(() => {
    const lines = document.querySelectorAll(".fade-line");
    const initialDelay = 300;
    const staggerDelay = 250;
    lines.forEach((line, i) => {
      setTimeout(() => line.classList.add("visible"), initialDelay + (staggerDelay * i));
    });
  }, []);

  return (
    <div className="hero">
      <img src={logo} alt="PeerfectCV Logo" className="logo" />

      <h1 className="headline fade-line">
        Introducing <span className="brand">PeerfectCV</span>
      </h1>

      {/* Text Block with Finalized Copy */}
      <h2 className="subheadline fade-line">
        Your resume is ready. But is it effective?
      </h2>
      <p className="subheadline fade-line">
        For weeks, you’ve edited every bullet point. Swapped fonts. Tweaked verbs. Googled "strong action words" more times than you’d admit.
      </p>
      <p className="intro fade-line">
        But here’s the truth: you’re not the one reading it.
      </p>
      <p className="tagline fade-line">
        PeerfectCV is your second set of eyes. Your hidden panel of reviewers. Your brutally honest friend in a sea of silence.
      </p>
      <p className="tagline fade-line">
        No fluff. No “looks good!” replies. Just real feedback that actually moves the needle.
      </p>

      {/* Button / Email Input Section */}
      {!showEmailInput ? (
        <button className="cta-button fade-line" onClick={handleStartClick}>
          Get Started
        </button>
      ) : (
        <div className={`email-overlay ${animateInput ? "reveal" : ""}`}>
          <p>Enter your email to begin</p>
          <input
            type="email"
            className="email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <button className="submit-button" onClick={handleEmailSubmit}>
            Submit
          </button>
          {message && <p className="message">{message}</p>}
        </div>
      )}
    </div>
  );
}

// App Router
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/form" element={<Form />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </Router>
  );
}

export default App;